module.exports = __webpack_public_path__ + "static/media/facebook.e6a7997b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Team/AboutBox/img/facebook.svg
// module id = 291
// module chunks = 0